<section class="fw-flex fw-col fw-gap-3 tw-overflow-y-auto tw-h-full">
  <div class="variable-elements-container">
    <h3 class="fw-bold small text-dark">
      {{ parentVariableElements?.length ? "Child Variable Elements" : "Variable Elements" }}
    </h3>
    <div class="d-flex flex-column gap-2" cdkDropList [cdkDropListDisabled]="!selectedTemplate" [cdkDropListSortingDisabled]="true">
      @for(variableElement of variableElements; track variableElement){
        <app-variable-element [selectedTemplate]="selectedTemplate" [variableElement]="variableElement" [class]="'element_' + variableElement.field_type"></app-variable-element>
      }
    </div>
  </div>
  @if(parentVariableElements?.length){
    <div class="variable-elements-container">
      <h3 class="fw-bold small text-dark">Parent Variable Elements</h3>
      <div class="d-flex flex-column gap-2" cdkDropList [cdkDropListDisabled]="!selectedTemplate" [cdkDropListSortingDisabled]="true">
        @for(variableElement of parentVariableElements; track variableElement){
          <app-variable-element [selectedTemplate]="selectedTemplate" [variableElement]="variableElement" [class]="'element_' + variableElement.field_type"></app-variable-element>
        }
      </div>
    </div>
  }
</section>
